
import React from 'react';
import './Legend.css';

const Legend = () => {
  return (
    <div className="legend">
      <h4>AQI (大気質指数)</h4>
      <div><span style={{ backgroundColor: '#009966' }}></span>0 - 50 (良好)</div>
      <div><span style={{ backgroundColor: '#ffde33' }}></span>51 - 100 (普通)</div>
      <div><span style={{ backgroundColor: '#ff9933' }}></span>101 - 150 (敏感な人には不健康)</div>
      <div><span style={{ backgroundColor: '#cc0033' }}></span>151 - 200 (不健康)</div>
      <div><span style={{ backgroundColor: '#660099' }}></span>201 - 300 (非常に不健康)</div>
      <div><span style={{ backgroundColor: '#7e0023' }}></span>301+ (危険)</div>
      <hr />
      <h4>黄砂</h4>
      <div><span className="dust-symbol"></span>黄砂</div>
    </div>
  );
};

export default Legend;
